import React from "react";
import styles from "./portrait-with-name.module.css";
import { LOCALES, SAVIOR_ATTRIBUTE, SAVIOR_CLASS } from "../../../constants";

export default function PortraitWithName({ lang, savior, onSelect }) {
    const eng = savior.attr.replace("NUAT_", "").toLowerCase();

    return (
        <div className={styles["savior"]} onClick={() => onSelect(savior)}>
            <div className={`${styles["portrait"]} ${styles[`${eng}`]}`}>
                <img
                    alt={savior.name[lang]}
                    src={`${process.env.PUBLIC_URL}/images/icon/portrait/${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]}).webp`}
                />
                <div className={styles["class-overlay"]}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/icon/portrait/${SAVIOR_ATTRIBUTE[savior.attr][LOCALES.KO]}.webp`}
                        className={styles["attr"]}
                    />
                    <img
                        src={`${process.env.PUBLIC_URL}/images/icon/portrait/${SAVIOR_CLASS[savior.class][LOCALES.KO]}.webp`}
                        className={styles["class"]}
                    />
                </div>
            </div>
            <div className={styles["name-wrapper"]}>
                <div className={styles["name"]}>{savior.name[lang]}</div>
                <div className={styles["title"]}>{savior.title[lang]}</div>
            </div>
        </div>
    );
}
